var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c(_vm.modal,_vm._b({tag:"component"},'component',_vm.modalParams,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }